import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import AlarmHistoryItem from '../../../components/Alerts/AlarmHistoryItem';
import { Paginator } from 'primereact/paginator';
import paginatorStyles from '../../../components/PerinHealthGrid.module.css';
import patientStyles from '../Patient.module.css'
import { getAlertTimestamp } from '../../../utils/alertUtils';

const AlarmHistoryDetails = (props) => {

    const {
        historySort,
        selectedAlertTypes,
        searchText,
        alertsHistory
    } = props;

    const userDateFormat = useSelector((state) => state.userInfo.dateFormat);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);


    const sortedHistory = [...alertsHistory]
        .filter((alert) => {
            const matchesAlertType =
                selectedAlertTypes.length === 0 ||
                selectedAlertTypes.some(type => type.value === alert.alert_category);

            const matchesSearchText = searchText === "" || alert.alert_description?.toLowerCase().includes(searchText.toLowerCase());
            return matchesSearchText && matchesAlertType;
        })
        .sort((a, b) => {
            const timestampA = getAlertTimestamp(a);
            const timestampB = getAlertTimestamp(b);
            const startDateA = new Date(timestampA);
            const startDateB = new Date(timestampB);
            return historySort === "ascending" ? startDateA - startDateB : startDateB - startDateA;
        });

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    const currentItems = useMemo(() => {
        return sortedHistory.slice(first, first + rows);
    }, [sortedHistory, first, rows]);

    return (
        <div style={{display:"flex", flexDirection:"column", height:"100%"}}>
            <div style={{ 
                flex: 1, 
                minHeight: 0, 
                overflowY: "auto", 
                display: "flex", 
                flexDirection: "column", 
                gap: "10px" 
            }}>
                {currentItems.map((alert, index) =>  
                    <AlarmHistoryItem alert={alert} dateFormat={userDateFormat} key={`${alert.alertId}-${index}`} />
                )}
                {currentItems.length === 0 &&
                    <div className={patientStyles.emptyView}>
                        No alarms found
                    </div>
                }
            </div>
            <div style={{display:"flex", alignItems:"center", paddingTop:"10px", justifyContent:"space-between", width:"740px"}}>
                <span 
                    style={{ 
                        fontFamily: 'Roboto',
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '16px',
                        textAlign: 'left',
                        color: '#25282B'
                    }}>
                        Total Number: {sortedHistory.length}
                    </span>
                <Paginator 
                    className={paginatorStyles.customPaginator}
                    first={first}
                    rows={rows}
                    totalRecords={sortedHistory.length}
                    onPageChange={onPageChange}
                    template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink "
                />
            </div>
        </div>
    );
}

export default AlarmHistoryDetails;